"use client";
import { jsx as e } from "react/jsx-runtime";
import { Overlay as s, Root as d, Content as m, Close as c } from "../atoms/dialog.js";
import { ikp as r } from "./factory.js";
import { CustomIcon as p } from "../atoms/icons/custom-icon.js";
import { useInkeepModal as C } from "./modal/use-inkeep-modal.js";
import { ModalProvider as M, useModal as f } from "./modal/modal-provider.js";
import { composeEventHandlers as u } from "../utils/compose-event-handlers.js";
import { useMediaQuery as v } from "../hooks/use-media-query.js";
import { dataAttr as _ } from "../utils/misc.js";
const O = r(d, {
  _id: "modal"
}), E = (o) => {
  const { onOpenChange: t, config: i, ...a } = o, n = C(i);
  return /* @__PURE__ */ e(M, { modal: n, children: /* @__PURE__ */ e(
    O,
    {
      open: n.isOpen,
      onOpenChange: u(t, (l) => n.setOpen(l)),
      ...a
    }
  ) });
}, H = r(s, {
  _id: "modal__Overlay"
}), y = r(m, {
  _id: "modal__Content",
  "aria-describedby": void 0
}), K = (o) => {
  const t = v("(max-width: 768px)");
  return /* @__PURE__ */ e(y, { "data-mobile": _(t), ...o });
}, h = r(c, {
  _id: "modal__Close",
  children: /* @__PURE__ */ e(p, { iconKey: "close" })
}), Q = (o) => f() ? /* @__PURE__ */ e(h, { ...o }) : null;
export {
  Q as Close,
  K as Content,
  E as Modal,
  H as Overlay
};
